import { Component, inject } from '@angular/core';
import { AuthService } from '@common-services/util/auth.service';
import { NotificationsActions } from '@dice/app/store/notifications/notifications.actions';
import { NotificationsState } from '@dice/app/store/notifications/notifications.state';
import { ProfileState } from '@dice/app/store/profile/profile.state';
import { ProfileNotification } from '@dice/app/types/notification.types';
import { Select, Store } from '@ngxs/store';
import { PROFILE_STATE } from '@profile/app/constants/state.const';
import { Components } from '@swisscom/sdx';
import { StateService } from '@uirouter/angular';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'profile-fly-out-menu',
  templateUrl: './profile-fly-out-menu.component.html',
  standalone: false,
})
export class ProfileFlyOutMenuComponent {
  private authService = inject(AuthService);
  private stateService = inject(StateService);
  private store = inject(Store);

  @Select(ProfileState.fullName) fullName$: Observable<string>;

  @Select(ProfileState.organizationalUnit) organizationalUnit$: Observable<string>;

  @Select(ProfileState.thumbnail) thumbnail$: Observable<string>;

  @Select(NotificationsState.newestUserNotifications) newestNotifications: Observable<ProfileNotification[]>;

  @Select(NotificationsState.allUserNotifications) allNotifications$: Observable<ProfileNotification[]>;

  private readonly unsubscriber: Subject<void> = new Subject<void>();

  private sdxMenuFlyOut: Components.SdxMenuFlyout;

  ngAfterViewInit(): void {
    this.sdxMenuFlyOut = window.document.querySelector('sdx-menu-flyout');
    this.closeFlyOutMenu();
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
  }

  navigateToProfile = (): void => {
    this.stateService.go(`dice.${PROFILE_STATE.PROJECT}`, {});
    this.closeFlyOutMenu();
  };

  logout = (): void => {
    this.authService.logout();
    this.closeFlyOutMenu();
  };

  clearAllNotifications = (): void => {
    this.store.dispatch(new NotificationsActions.DeleteAllNotifications());
  };

  private closeFlyOutMenu(): void {
    this.sdxMenuFlyOut.close();
  }
}
